import { memo } from 'react';
import { classNames } from '~/utils/classNames';

import styles from './LightRays.module.scss';

export const LightRaysCore = memo(
  ({ className, theme, chatStarted }: { className?: string; theme?: string; chatStarted?: boolean }) => {
    return (
      <div className={classNames(styles.RayContainer, className)} data-theme={theme} data-chat-started={chatStarted}>
        <div className={classNames(styles.LightRay, styles.RayOne)} />
        <div className={classNames(styles.LightRay, styles.RayTwo)} />
        <div className={classNames(styles.LightRay, styles.RayThree)} />
        <div className={classNames(styles.LightRay, styles.RayFour)} />
        <div className={classNames(styles.LightRay, styles.RayFive)} />
      </div>
    );
  },
);

LightRaysCore.displayName = 'LightRaysCore';
